/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBigLeft = createReactComponent("outline", "arrow-big-left", "IconArrowBigLeft", [["path", { "d": "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z", "key": "svg-0" }]]);

export { IconArrowBigLeft as default };
//# sourceMappingURL=IconArrowBigLeft.mjs.map
